module.exports = __webpack_public_path__ + "resources/img/logo_payco.6c17a576da7fe7a8ba8230e04ac5d0e5.png";